import { getLocale } from "../runtime";

const sv_popularsearches = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Populära sökningar`
};

const popularsearches = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_popularsearches(inputs)
	return "popularSearches";
};

export { popularsearches as "popularSearches" };